import React, { useState, useCallback } from 'react';
import CustomerPortalSection from '../components/CustomerPortalSection';
import { PlanSelectionProvider } from '../contexts/PlanSelectionContext';
import Header from '@shared/components/ui/Header';
import Footer from '@shared/components/ui/Footer';
import type { CustomerPortalSection as CustomerPortalSectionType } from '../types/customer-portal';
import { getUtmQsParams } from '@shared/utils/utmUtils';

interface CustomerPortalProps {
  className?: string;
}

const CustomerPortalComponent: React.FC<CustomerPortalProps> = ({ className = '' }) => {
  const [triggerBuyNow, setTriggerBuyNow] = useState(0);
  const [triggerLogoClick, setTriggerLogoClick] = useState(0);
  const [activeSection, setActiveSection] = useState<CustomerPortalSectionType>('landing');

  const utmQsParams = getUtmQsParams(new URLSearchParams(location.search));

  const handleBuyNowClick = () => {
    // Trigger the buy now action by incrementing the counter
    setTriggerBuyNow(prev => prev + 1);
  };

  const handleLogoClick = () => {
    // Navigate to customer portal root and trigger reset to landing section
    window.location.href = `/${utmQsParams}`;
    setTriggerLogoClick(prev => prev + 1);
  };

  // Callback to receive active section updates from child component
  const handleActiveSectionChange = useCallback((section: CustomerPortalSectionType) => {
    setActiveSection(section);
  }, []);

  // Determine if Header/Footer should be shown based on active section
  const shouldShowHeaderFooter = () => {
    return activeSection !== 'policy-verification-success' &&
           activeSection !== 'policy-verification-invalid';
  };

  const showHeaderFooter = shouldShowHeaderFooter();

  return (
    <PlanSelectionProvider>
      <div className={`min-h-screen flex flex-col bg-white ${className}`}>
        <main className="flex-1">
          {showHeaderFooter && (
            <Header
              onBuyNowClick={handleBuyNowClick}
              onLogoClick={handleLogoClick}
            />
          )}
          <CustomerPortalSection
            triggerBuyNow={triggerBuyNow}
            triggerLogoClick={triggerLogoClick}
            onActiveSectionChange={handleActiveSectionChange}
          />
          {showHeaderFooter && <Footer />}
        </main>
      </div>
    </PlanSelectionProvider>
  );
};

export default CustomerPortalComponent;